/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SeoMetaControllerGetMetaQueryResponse,
  SeoMetaControllerGetMetaPathParams,
  SeoMetaControllerGetMetaQueryParams,
  SeoMetaControllerGetMeta400,
  SeoMetaControllerGetMeta401,
  SeoMetaControllerGetMeta404,
} from '../types/SeoMetaControllerGetMeta.ts';

function getSeoMetaGetMetaUrl(pageType: SeoMetaControllerGetMetaPathParams['pageType']) {
  const res = { method: 'GET', url: `/api/seo-meta/${pageType}` as const };
  return res;
}

/**
 * {@link /api/seo-meta/:pageType}
 */
export async function seoMetaGetMeta(
  pageType: SeoMetaControllerGetMetaPathParams['pageType'],
  params?: SeoMetaControllerGetMetaQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SeoMetaControllerGetMetaQueryResponse,
    ResponseErrorConfig<SeoMetaControllerGetMeta400 | SeoMetaControllerGetMeta401 | SeoMetaControllerGetMeta404>,
    unknown
  >({ method: 'GET', url: getSeoMetaGetMetaUrl(pageType).url.toString(), params, ...requestConfig });
  return res.data;
}
